var map = {
	"./basic-electrical.svg": 74981,
	"./basic-flowchart.svg": 85429,
	"./block-diagram.svg": 33379,
	"./chen.svg": 55044,
	"./cross-functional-vertical.svg": 63457,
	"./mind-map.svg": 41565,
	"./organization-chart.svg": 6262,
	"./plan.svg": 22241,
	"./recommended-2.svg": 93216,
	"./roadmap.svg": 20328,
	"./software-architecture.svg": 4785,
	"./uml-model-diagram.svg": 43014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87364;